export default "__VITE_ASSET__C_8$T4Fy__"